import { ApplicationController } from "../application_controller";

export default class extends ApplicationController {
  static targets = ["page_filter", "export_url", "view_type_url"]

  getFiltersValues() {
    let filters = {};
    if (this.hasPage_filterTarget) {
      this.page_filterTargets.forEach(el => {
        if ((el.choices && el.choices.getValue(true).length) || el.value) {
          switch (el.name) {
            case "search":
              filters["q"] = el.value;
              break;

            case "supplier[]":
              filters["supplier_ids"] = el.choices.getValue(true);
              break;
            case "deals_ids[]":
              filters["deal_ids"] = el.choices.getValue(true);
              break;
            case "service_types[]":
              filters["service_type_ids"] = el.choices.getValue(true);
              break;
            case "suppliers_ids[]":
              filters["supplier_ids"] = el.choices.getValue(true);
              break;
            case "accounts_ids[]":
              filters["account_ids"] = el.choices.getValue(true);
              break;

            default:
              if (el.name.match(/\[\]$/)){
                filters[el.name.split(/\[\]/)[0]] = el.choices.getValue(true);
              }
              else {
                filters[el.name] = el.value;
              }
              break;
          }
        }
      })
    }

    return filters;
  }

  columnsSelectClick(e) {
    e.preventDefault();

    let button = e.currentTarget;
    button.disabled = true;

    let form = button.closest("form");
    let url = form.action;
    let filters = new URLSearchParams(this.getFiltersValues());
    const content_element = document.getElementById("content");
    const formData = new FormData(form);
    for (let pair of formData.entries()) {
      filters.append(pair[0], pair[1]);
    }
    filters.append("load_type", "columns_select");
    url += "?" + filters;

    fetch(url, {
      method: 'GET',
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].getAttribute('content'),
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin'
    }).then((response) => {
      if (response.status == 200) {
        response.text().then((content) => {
          content_element.innerHTML = JSON.parse(content)["page_content"];
        })
      }
    });
  }

  pageLinkClick(e) {
    e.preventDefault();
    let button = e.currentTarget;
    button.classList.add('disabled');

    let filters = new URLSearchParams(this.getFiltersValues());
    let page_url = e.currentTarget.href;

    if (filters.toString())
      page_url += "?" + filters

    let a = document.createElement('a');
    a.href = page_url;
    document.body.appendChild(a);
    a.click();
  }

  exportClick(e) {
    e.preventDefault();
    let button = e.currentTarget;
    button.classList.add('disabled');

    let filters = this.getFiltersValues();
    let download_url = new URL(button.href);
    let filter_params = new URLSearchParams(download_url.search);
    let filter_index = 0;

    Object.entries(filters).forEach(([key, value]) => {
      let normalized_value = Array.isArray(value)
        ? value.filter(v => `${v}`.length).join(',')
        : value;

      if (!`${normalized_value}`.length) return;

      // Backward compatible flat params used by many export endpoints.
      filter_params.set(key, normalized_value);

      // Deals mapping persistence expects nested filters payload.
      filter_params.set(`filters[${filter_index}][field]`, key);
      filter_params.set(`filters[${filter_index}][value]`, normalized_value);
      filter_index += 1;
    });

    download_url.search = filter_params.toString();

    let a = document.createElement('a');
    a.href = download_url.toString();
    document.body.appendChild(a);
    a.click();
    a.remove();

    button.classList.remove('disabled');
  }
}
